import { useQuery } from "@tanstack/react-query";
import { fetchBlogs, fetchBlog } from "../lib/api";

export const useBlogs = () =>
  useQuery({
    queryKey: ["blogs"],
    queryFn: fetchBlogs,
  });

export const useBlog = (slug) =>
  useQuery({
    queryKey: ["blog", slug],
    queryFn: () => fetchBlog(slug),
    enabled: !!slug,
    retry: false,
  });
